module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (202).03e68046.jpg";